import './TrackmanParametersTabCategories.scss';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';
import { ParameterModel } from 'types/trackmanParameters';
import { Tab, Tabs } from '@trackman/web-shared-components';

type TrackmanParametersTabCategoriesProps = {
  categoriesList: [string, ParameterModel[]][];
  selectedCategoryIndex: number;
  selectedSubjectIndex: number;
  selectCategory: (categoryIndex: number) => void;
  selectSubject: (subjectIndex: number) => void;
};
export const TrackmanParametersTabCategories = ({
  categoriesList,
  selectedCategoryIndex,
  selectedSubjectIndex,
  selectCategory,
  selectSubject,
}: TrackmanParametersTabCategoriesProps) => {
  const { t } = useTranslation();

  return (
    <div className='categories-and-parameters-container'>
      <div className='categories-container'>
        <Paragraph>
          <>{t('Categories', { ns: 'trackmanParameters' })}</>
        </Paragraph>
        <Tabs className='categories-list' value={selectedCategoryIndex}>
          {categoriesList.map(([categoryName, subcategories], index) => (
            <Tab label={t(categoryName, { ns: 'trackmanParameters' })} key={categoryName} onClick={() => selectCategory(index)} />
          ))}
        </Tabs>
      </div>
      <div className='parameters-list'>
        {categoriesList[selectedCategoryIndex][1].map((parameter, index) => (
          <div
            className={selectedSubjectIndex === index ? 'parameter-entry parameter-entry__active' : 'parameter-entry'}
            key={parameter.id}
            onClick={() => selectSubject(index)}
          >
            {t(parameter.title, { ns: 'trackmanParameters' })}
          </div>
        ))}
      </div>
    </div>
  );
};
